module.exports = { src: __webpack_public_path__ + "media/tile-3-image.c82aee5e.webp", width: 540, height: 375 };